<template>
    <div class="roleManagementPage">
        <headerNotice routerName="用户列表"></headerNotice>

        <!-- 搜索结果列表 -->
        <div class="searchList" v-loading="loading">
            <div class="searchListHead">
                <h2 class="searchListTitle">
                    <i></i>
                    <span class='title'>数据列表</span>
                </h2>
                <div class="searchListCtl">
                    <el-button @click="addRole">添加</el-button>
                    <!-- <el-select @change='so' v-model="searchListCtlForm.arrange" placeholder="排列方式">
                        <el-option label="默认排列方式" value></el-option>
                        <el-option label="按客户名" value="1"></el-option>
                        <el-option label="按业务员" value="2"></el-option>
                    </el-select> -->
                </div>
            </div>
            <div class="searchListContent">
                <el-table
                    ref="searchListTable"
                    :data="searchListTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    border
                >
                    <el-table-column prop="divisionName" label="角色名称"></el-table-column>
                    <el-table-column prop="remark" label="角色描述"></el-table-column>
                    <el-table-column prop="count" label="成员数量"></el-table-column>
                    <el-table-column prop="createTime" label="添加时间"></el-table-column>
                    <el-table-column prop="status" label="启用状态" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status ==0">未启用</span>
                            <span v-if="scope.row.status ==1">启用</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click='toSetting(scope.row)'>权限设置</el-button>
                            <el-button type="text" size="small" @click='editRole(scope.row)'>编辑</el-button>
                            <el-button type="text" size="small" @click="deleteRole(scope.row.divisionID)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--搜索列表分页-->
        <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync='currentPage'
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
        ></el-pagination>
        <!-- 添加弹框 -->
        <el-dialog :title="formTitle" :visible.sync="addRoleFormVisible" width="30%">
            <el-form ref='form' :rules='rules' :model="addRoleForm" label-width="100px">
                <el-form-item prop='divisionName' label="角色名称">
                    <el-input v-model="addRoleForm.divisionName"></el-input>
                </el-form-item>
                <el-form-item prop='remark' label="角色描述">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 6}"
                        placeholder="请输入内容"
                        v-model="addRoleForm.remark"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetAddRoleForm">取 消</el-button>
                <el-button type="primary" @click="sendAddRoleForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: true,
            totalCount: 0,//总数据条数
            couponTotalCount: 0,
            customerSalesmanTotalCount: 0,
            currentPage: 1,
            maxResultCount: 10, //默认一页显示的个数,
            searchListCtlForm: {//排列方式
                arrange: ''
            },
            searchListTableData: [],
            addRoleFormVisible: false,//显示增加弹窗
            addRoleForm: {//增加表单
            },
            rules: {
                divisionName: {required: true, message: '请输入角色名称', trigger: 'change'},
                remark: {required: true, message: '请输入角色描述', trigger: 'change'}
            },
            formTitle: '',
            timer: ''
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
        });
    },
    watch: {
        addRoleFormVisible(val) {
            if(!val) {
                if(this.timer) {
                    clearTimeout(this.timer)
                }
                this.timer = setTimeout(() => {
                    this.addRoleForm = {}
                    this.$refs.form.resetFields()
                }, 20)
            }
        }
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/Division/GetAll",
                params: params,
                success(res) {
                    self.searchListTableData = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    console.log(res);
                    self.loading = false;
                }
            })
        },
        // 设置
        toSetting(data) {
            this.$router.push({
                path: '/authoritySetting',
                query: {
                    divisionID: data.divisionID,
                    divisionName: encodeURI(data.divisionName)
                }
            })
        },
        //添加
        addRole() {
            this.addRoleFormVisible = true;
            this.formTitle = '添加角色'
        },
        // 编辑
        editRole(data) {
            this.addRoleFormVisible = true; 
            this.formTitle = '编辑角色'
            this.addRoleForm.divisionName = data.divisionName
            this.addRoleForm.remark = data.remark
            this.addRoleForm.divisionID = data.divisionID
        },
        //删除用户
        deleteRole(id) {
            this.$confirm('此操作将永久删除该客户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
            let params = {
                divisionID: id
            }
            let self = this;
            $http.DELETE({
                url: this.$store.state.apiUrl + "/api/services/app/Division/DeleteDivision",
                params: params,
                success(res) {
                    self.$message.success('操作成功！')
                    self.getDatas()
                    self.currentPage = 1
                },
                fail(res) {
                }
            })
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });
        });
        },
        // 验证
        sendAddRoleForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // console.log(this.form)
                    if(this.formTitle == '添加角色') {
                        this.createRole()
                    }else {
                        this.updateRole()
                    }  
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 更新
        updateRole() {
            let self = this;
            // self.loading = true;
            $http.PUT({
                url: this.$store.state.apiUrl + "/api/services/app/Division/Update",
                data: self.addRoleForm,
                success(res) {
                    self.$message.success('操作成功！')
                    // self.loading = false;
                    self.addRoleFormVisible = false; 
                    self.getDatas()
                    self.currentPage = 1
                },
                fail(res) {
                    console.log(res);
                    // self.loading = false;
                }
            })
        },
        //提交
        createRole() {
            // validate = this.addRoleForm.
            let self = this;
            // self.loading = true;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/Division/Create",
                data: self.addRoleForm,
                success(res) {
                    self.$message.success('操作成功！')
                    // self.loading = false;
                    self.addRoleFormVisible = false; 
                    self.getDatas()
                    self.currentPage = 1
                },
                fail(res) {
                    console.log(res);
                    // self.loading = false;
                }
            })
        },
        //重置关闭审核表单
        resetAddRoleForm() {
            this.addRoleForm.name = '';
            this.addRoleForm.remark = '';
            this.addRoleFormVisible = false
        },
        //搜索列表一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
            };
            this.getDatas(params);
        },
        //搜索列表跳转到指定页
        handleCurrentChange(val) {
            let skipCount = (val - 1) * this.maxResultCount;
            let params = {};
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            this.getDatas(params);
        },
    }
}
</script>

<style lang='scss' scoped>
.roleManagementPage {
    //搜索框
    .searchBox {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchTitle {
            display: flex;
            align-items: center;
            height: 40px;
            margin-bottom: 10px;
            padding-left: 20px;
            background: #efefef;
            border-bottom: 1px solid #c5c5c5;
            i {
                width: 24px;
                height: 24px;
                background: url("../../assets/imgs/search01.png");
            }
        }
        .searchForm {
            display: flex;
            align-items: center;
            height: 60px;
            padding-left: 20px;
            .el-form-item {
                margin-bottom: 0;
            }
        }
    }
    //搜索列表
    .searchList {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchListHead {
            display: flex;
            align-items: center;
            justify-content: space-between;
            // height: 40px;
            padding-left: 20px;
            background: #efefef;
            border-bottom: 1px solid #c5c5c5;
            .searchTitle {
                i {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/imgs/search02.png");
                }
            }
            .searchListCtl {
                button,
                .el-select {
                    width: 130px;
                    margin-left: 10px;
                    margin-right: 20px;
                }
            }
        }
        .title {
            line-height: 50px;
        }
        .searchListContent {
            .detialSpan {
                color: #ff9400;
                cursor: pointer;
            }
        }
    }
}
</style>
<style lang="scss">
.roleManagementPage {
    .el-dialog__header {
        background: #efefef;
        border-bottom: 1px solid #c5c5c5;
    }
}
</style>